var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { canInsert } from "@dc-extension-rich-text/common";
import Directions from "@material-ui/icons/Directions";
import React from "react";
export function AnchorTool(schema, dialog) {
    return {
        name: "anchor",
        label: "Insert Anchor",
        displayIcon: React.createElement(Directions, null),
        apply: insertAnchor(schema.nodes.anchor, dialog),
        isEnabled: function (state) { return canInsert(state, schema.nodes.anchor); },
    };
}
export function insertAnchor(type, dialog) {
    var _this = this;
    return function (state, dispatch, view) { return __awaiter(_this, void 0, void 0, function () {
        var existingAnchors_1, addAnchor_1, _a, $from, $to, anchorValue, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!dialog) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    existingAnchors_1 = new Set();
                    addAnchor_1 = function (node) {
                        if (node.type.name === 'anchor') {
                            existingAnchors_1.add(node.attrs.value);
                        }
                        else {
                            node.forEach(addAnchor_1);
                        }
                    };
                    state.doc.forEach(addAnchor_1);
                    _a = state.selection, $from = _a.$from, $to = _a.$to;
                    state.doc.nodesBetween($from.pos, $to.pos, function (node, start) {
                        if (node.type.name === 'anchor') {
                            existingAnchors_1.delete(node.attrs.value);
                        }
                    });
                    return [4 /*yield*/, dialog(existingAnchors_1)];
                case 2:
                    anchorValue = _b.sent();
                    view.dispatch(view.state.tr.replaceSelectionWith(type.createAndFill({
                        value: anchorValue.value
                    })));
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
